export default function NotFound() {
  return <div className="p-6 text-gray-500">404 — Page not found</div>;
}